module.exports = __webpack_public_path__ + "img/instagram.087486b3.png";